import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },

  icon: {
    marginRight: '0.5rem',
    cursor: 'pointer',
    height: '1rem',
    width: '1rem'
  }
}))

export default useStyles
